import { BTFloatingActionBar } from "@btnet/core-components/BTFloatingActionBar";

export interface IBillApprovalQueueFloatingActionBarProps {
    selectedCount: number;
    onDeselect: () => void;
    onApprove: () => void;
    disabled: boolean;
}

export function BillApprovalQueueFloatingActionBar(
    props: IBillApprovalQueueFloatingActionBarProps,
) {
    const { selectedCount, onDeselect, onApprove, disabled } = props;

    return (
        <BTFloatingActionBar
            testid="billApprovalQueueActionBar"
            selectedCount={selectedCount}
            onDeselect={onDeselect}
        >
            <BTFloatingActionBar.Action
                id="bulkApprove"
                testid="bulkApprove"
                disabled={disabled}
                onClick={onApprove}
            >
                Approve
            </BTFloatingActionBar.Action>
        </BTFloatingActionBar>
    );
}
